module.exports = __webpack_public_path__ + "static/media/graphic-design-icon@4x.0e9f5873.png";